import styled from 'styled-components';

export const InputContainer = styled.div`
  display: flex;
  flex: 1;

  input.formInput {
    width: 100%;
  }
`;